import React, { useMemo } from 'react';
import format from 'date-fns/format';
import PropTypes from 'prop-types';
import _startCase from 'lodash/startCase';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import BoxWithTwoSections from 'components/BoxWithTwoSections';
import { DATE_WITH_HOUR } from 'utils/dateFormat';

import { transactionDetails as TEXT } from 'locales/en/transaction';

const TransactionDetails = ({ transaction }) => {
  const leftSide = useMemo(
    () => ({
      id: transaction.id,
      created_at: format(new Date(transaction.created_at), DATE_WITH_HOUR),
      merchantRef: transaction.merchant_reference,
      fraudScore: transaction.risk_score,
      amount: transaction.amountToDisplay,
      status: _startCase(transaction.status),
      net: transaction.netBalanceToDisplay,
      psp: transaction.external_id,
    }),
    [transaction]
  );
  const rightSide = useMemo(
    () => ({
      company: transaction.company?.name,
      orderId: transaction.order_id ? (
        <p className="text-javelin-blue cursor-pointer">
          {transaction.order_id}
        </p>
      ) : (
        '-'
      ),
      cardId: transaction.card_id,
      statement: transaction.statement_descriptor,
      failure: transaction.fail_reason,
      last: format(new Date(transaction.updated_at), DATE_WITH_HOUR),
      liability: transaction.liability_shift ? (
        <FontAwesomeIcon
          icon="check"
          size="lg"
          className="text-green-lowRisk my-auto p-1 bg-green-lowRisk bg-opacity-20 rounded-full"
        />
      ) : (
        <FontAwesomeIcon
          icon="times"
          size="lg"
          className="fa-w-16 p-0.5 text-javelin-danger bg-javelin-danger bg-opacity-20 text-opacity-50 rounded-full"
        />
      ),
    }),
    [transaction]
  );
  return (
    <>
      <h2 className="text-javelin-gray-dark lg:text-xl text-base font-bold">
        {TEXT.details.header}
      </h2>
      <BoxWithTwoSections
        textObject={TEXT.details}
        data={{ left: leftSide, right: rightSide }}
      />
    </>
  );
};

TransactionDetails.propTypes = {
  transaction: PropTypes.shape({}),
};
TransactionDetails.defaultProps = {
  transaction: {},
};

export default TransactionDetails;
